import { asPartialIEnvironment, Env, IEnvironment } from '../environment.interface';
import { environmentBase } from './environment.base';

export const environmentLocal: IEnvironment = {
  ...environmentBase,
  ...asPartialIEnvironment({
    environment: Env.DEV,
    baseUrl: 'http://localhost:3000',
    authBaseUrl: 'https://auth.backoffice.dev.vivela.io',
    googleAuthClientId: '6iij4o83qgl87i3f8svfv8bce1',
    authCallbackUrl: 'http://localhost:4200/callback',
    recaptchaSiteKey: '6Lf8Ln0hAAAAAIyfpLAYUehtKnQZ-r-SwyV_-7g2',
  }),
};
